
document.addEventListener('DOMContentLoaded', () => {


    function resetScroll(){
        setTimeout(()=>{
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: "smooth"
            })
            document.documentElement.scrollTop = 0;
            document.body.scrollTop = 0;
        },200)
    }


    function initFormControls(customClass) {
        const formControls = document.querySelectorAll(".globo-form-control");

        if (formControls.length === 0) return false;         
        formControls.forEach(formControl => {
            if (formControl.classList.contains(customClass)) {
                
                const startBtn = formControl.querySelector('.globo-option');
                const parent = formControl.closest(".wizard__content");
                const nextBtn = parent ? parent.querySelector(".next") : null;


                if (startBtn && nextBtn) {
                    startBtn.addEventListener('click', (e) => {
                        e.preventDefault();
                        setTimeout(() => {
                            if (customClass === 'product-comment__btn'){
                                copyComment('wr-text-area', 'amzn-text-area');
                                nextBtn.click();
                                resetScroll()
                                return
                            }
                            if (nextBtn.classList.contains('submit') && customClass === "back-to-homepage"){
                                nextBtn.click();
                                
                                return
                            }
                            nextBtn.click();
                            resetScroll()
                        }, 400);
                        
                    });
                }
            }
        });

        return true; 
    }

    function createGiftTextElement(el){
        const giftItem = el.lastElementChild.textContent
        const giftItemContainer = document.createElement('p');
        giftItemContainer.textContent = giftItem;
        giftItemContainer.style.textAlign = "center";
        giftItemContainer.style.paddingBottom = "0.35em";
        el.parentNode.insertBefore(giftItemContainer, el);
        el.lastElementChild.textContent = "I Want This Gift!"
        return giftItem
    }

    function getSelectedGiftDetails(el, giftName) {

        const parentNode = el.closest(".gfb__image-option__wrapper")
        const img = parentNode ? parentNode.querySelector("img") : null;
        const imgSrc = img ? img.src : ''

        sessionStorage.setItem("giftName",giftName);
        sessionStorage.setItem("giftImg",imgSrc)   
    }

    function selectGift(customClass) {
        
        const formControls = document.querySelectorAll(".globo-form-control");
        
        if (formControls.length === 0) return false; 

        formControls.forEach(formControl => {
            if (formControl.classList.contains(customClass)) {
                
                const startBtns = formControl.querySelectorAll('.radio-wrapper');
                const parent = formControl.closest(".wizard__content");
                const nextBtn = parent ? parent.querySelector(".next") : null;
                
                if (startBtns && nextBtn) {
                    startBtns.forEach(startBtn => {
                        let giftName = createGiftTextElement(startBtn)
                        startBtn.addEventListener('click', (e) => {
                            if (e.target !== startBtn.lastElementChild) return;

                            startBtn.firstElementChild.checked = true;
                            getSelectedGiftDetails(startBtn, giftName)
                            setTimeout(() => {
                               
                                nextBtn.click(); 
                                resetScroll()
                            }, 400);
                            
                        });
                    })
                }
            }
        });

        return true; 
    }


    function domObserver(customClass) {
        
        const observer = new MutationObserver(() => {
            if (initFormControls(customClass)) {
                observer.disconnect(); 
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    function copyComment(txtAreaA, txtAreaB) {
        
        const formControls = document.querySelectorAll(".globo-form-control");
       
        
        if (formControls.length === 0) return false;
        let commentBoxA;
        let commentBoxB
        formControls.forEach(formControl => {
            if (formControl.classList.contains(txtAreaA)) {
                
                commentBoxA = formControl
            }
            if (formControl.classList.contains(txtAreaB)){
                commentBoxB = formControl
            }
        });
        const comment = commentBoxA.querySelector('textarea').value;
        commentBoxB.querySelector('textarea').value = comment;
        sessionStorage.setItem("comment", comment);
    }

    function setGiftDetails(){
        const giftName = sessionStorage.getItem("giftName");
        const giftImg = sessionStorage.getItem("giftImg");
        const giftItemName = document.querySelector(".gift-item-name");
        const giftItemImg = document.querySelector(".gift-item-img")
        giftItemName.textContent = giftName;
        giftItemImg.src = giftImg;

    }
    function redirectToAmazon(customClass){
        const formControls = document.querySelectorAll(".globo-form-control");
        
        if (formControls.length === 0) return false; 
        let nextBtn;
        let nextBtnProxy;
        formControls.forEach(formControl => {
             if (formControl.classList.contains("wr-last-step__btn")){
                
                nextBtnProxy = formControl.querySelector('.globo-option');
                const parent = formControl.closest(".wizard__content");
                nextBtn = parent ? parent.querySelector(".next") : null;

            }
            if (formControl.classList.contains(customClass)) {
                const link = formControl.querySelector('a');

                link.addEventListener("click", (e) => {
                    e.target.textContent = "COPIED!"
                    e.preventDefault()
                    const comment = sessionStorage.getItem("comment");
                    sessionStorage.removeItem("comment")
                    window.open(e.target.href, "_blank");
                    navigator.clipboard.writeText(comment).catch(() => {});
                    
                    setTimeout(() => {
                        setGiftDetails();
                       
                        nextBtnProxy.style.pointerEvents = "auto !important"
                        nextBtnProxy.style.border ="2px solid green"
                        nextBtnProxy.addEventListener('click', (e) => {
                            nextBtn.click();
                            resetScroll()
                        })
                    }, 1500);

                })
                

            }
           
        });
        return true; 
    }

    

    function togglePopUp(){
        const popUpTriggerContainer = document.querySelector('.activate-pop-up');
        if (!popUpTriggerContainer) return false;
        const popUp = document.querySelector('.findId');
        const closePopUpBtn = document.querySelector(".find-id-close-btn")
        const popUpBtn = popUpTriggerContainer.querySelector('.globo-paragraph')
        
        if (popUpBtn){
            popUpBtn.addEventListener("click", (e)=> {
                popUp.classList.remove('closed-pop-up')
            })
        }

        if (closePopUpBtn) {
            closePopUpBtn.addEventListener("click", (e) => {
                popUp.classList.add("closed-pop-up")
            })
        }
        return true
    }
    
    
    if (!initFormControls('purchase-point__btn')) {
        domObserver('purchase-point__btn')
    }
    
    if (!initFormControls('activate-warranty__btn')) {
        domObserver('activate-warranty__btn')
    }

    if (!initFormControls('product-comment__btn')) {
        domObserver('product-comment__btn')
    }
    if (!initFormControls('finish-submit')) {
        domObserver('finish-submit')
    }

    if (!initFormControls('back-to-homepage')){
        domObserver('back-to-homepage')
    }
    

    if (!selectGift('warranty-gifts')) {
        const observer = new MutationObserver(() => {
            if (selectGift('warranty-gifts')) {
                observer.disconnect(); 
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    if (!redirectToAmazon("redirect-amzn")){
        const observer = new MutationObserver(() => {
            if (redirectToAmazon('redirect-amzn')) {
                observer.disconnect(); 
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });

    }
    if (!togglePopUp()){
        const observer = new MutationObserver(() => {
            if (togglePopUp()) {
                observer.disconnect(); 
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }
    


});
